/**
 * Which public card shop URLs phase 1 of public gallery SSR (PRNT) server-renders: the bare
 * `/cards/wedding/:category` gallery, with no query param that changes which tiles show or in
 * what order. Read by the server renderer config and by the client gate added in PR 2, which
 * must agree. Kept free of app imports so the server's own bundle can read it.
 */

/**
 * The browsable gallery categories. Mirrors the keys of
 * `NAMED_CATEGORY_TO_STATIONERY_TEMPLATE_ENUM_MAP` in `Card.routes.tsx` (pinned by the spec);
 * duplicated rather than imported so the server config doesn't pull the router module in.
 */
export const GALLERY_CATEGORY_SLUGS: ReadonlyArray<string> = ['save-the-date', 'invitation', 'thank-you', 'holiday', 'enclosure', 'napkin', 'menu', 'sign'];

/**
 * Query params that change which tiles the gallery shows, or in what order. Tracking params
 * (utm_*, gclid, srsltid) are deliberately absent: they don't shape the gallery.
 */
export const GALLERY_SHAPING_PARAMS: ReadonlyArray<string> = ['pf', 'q', 'page', 'format', 'theme'];

const BARE_GALLERY_PATH = new RegExp(`^/cards/wedding/(${GALLERY_CATEGORY_SLUGS.join('|')})/?$`);

/** True for a public gallery page path, `/cards/wedding/:category` — not a PDP, cart, order or other `/cards` page. */
export const isGalleryPath = (pathname: string): boolean => BARE_GALLERY_PATH.test(pathname);

/** True when `search` (with or without the leading `?`) carries a gallery-shaping param. */
export const hasGalleryShapingParams = (search: string): boolean => {
  const params = new URLSearchParams(search);
  return GALLERY_SHAPING_PARAMS.some(key => params.has(key));
};

/** True for the URL phase 1 server-renders: a gallery path with no shaping param. */
export const isBareGalleryUrl = (pathname: string, search: string): boolean => isGalleryPath(pathname) && !hasGalleryShapingParams(search);
